import React, { useEffect } from 'react'
import { Redirect, useHistory } from 'react-router'
import { observer } from 'mobx-react-lite'
import { Image } from 'react-native'
import { setPageTitle } from '@trivie/core/src/utils/pageTitle'
import { useStores } from '@trivie/core/src/models/root-store/root-store-context'
import { AppStoreLinks } from '@trivie/ui-web/components/app-store-links'
import { Button } from '@trivie/ui-mobile/components/button'
import { Text } from '@trivie/ui-mobile/components/text'

const central = require('../../assets/central.png')

export const LoginScreen = observer(() => {
  const { userStore } = useStores()
  const { token, setSharedQuiz } = userStore
  const history = useHistory()

  useEffect(() => {
    setPageTitle(`Login - ${process.env.REACT_APP_SITE_TITLE}`)
    setSharedQuiz(null) // Reset any shared quiz stored
  }, [])

  /**
   * Navigate to the magic link screen
   * @returns void
   */
  const goToMagicLink = () => history.push('/login/magic')

  return token ? (
    <Redirect to="/library" />
  ) : (
    <div style={ROOT}>
      <Image
        source={central}
        style={{ width: 320, height: 335, marginBottom: 12, alignSelf: 'center' }}
      />
      <Text
        align="center"
        variant="headline"
        style={{ color: '#2F1E4F', marginBottom: 20 }}
        text="Learning that sticks."
      />
      <Text
        align="center"
        variant="titleMedium"
        style={{ color: '#2F1E4F99', marginBottom: 20 }}
        text="Boost your learning and train your brain with quizzes, head-to-head challenges, leaderboards, and more."
      />
      <Button
        accessibilityRole="link"
        accessibilityLabel="Go to Magic Link"
        tx="Onboarding.Login.logIn"
        onPress={goToMagicLink}
        fullWidth
        style={{ backgroundColor: '#2F1E4F', marginBottom: 20 }}
      />
      <AppStoreLinks
        google="https://play.google.com/store/apps/details?id=com.trivie.engage"
        apple="https://apps.apple.com/us/app/trivie-learn/id1568365105"
      />
    </div>
  )
})

const ROOT: React.CSSProperties = {
  height: '100%',
  maxHeight: 575,
  width: 335,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  margin: 'auto',
}
